import Link from 'next/link';

export function ComposeLegalFooter() {
  return (
    <p className="compose-legal-footer text-muted">
      By posting, you agree to our{' '}
      <Link href="/legal/terms/">Terms of Use</Link> and{' '}
      <Link href="/legal/community/">Community Guidelines</Link>.
    </p>
  );
}
